import { render, staticRenderFns } from "./VmUsagePanel.vue?vue&type=template&id=1f18da7e&"
import script from "./VmUsagePanel.vue?vue&type=script&lang=js&"
export * from "./VmUsagePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports